export const EmptyTopicsIllustration = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="137" height="126" viewBox="0 0 137 126" fill="none">
      <g clip-path="url(#clip0_17777_780659)">
        <path
          d="M128.5 80H8.5C4.35786 80 1 83.3579 1 87.5V117.5C1 121.642 4.35786 125 8.5 125H128.5C132.642 125 136 121.642 136 117.5V87.5C136 83.3579 132.642 80 128.5 80Z"
          stroke="#CACFD8"
          stroke-dasharray="5 3"
        />
        <path
          d="M126.5 84H10.5C7.46243 84 5 86.4624 5 89.5V115.5C5 118.538 7.46243 121 10.5 121H126.5C129.538 121 132 118.538 132 115.5V89.5C132 86.4624 129.538 84 126.5 84Z"
          fill="hsl(var(--neutral-100))"
        />
        <path
          d="M126.5 84H10.5C7.46243 84 5 86.4624 5 89.5V115.5C5 118.538 7.46243 121 10.5 121H126.5C129.538 121 132 118.538 132 115.5V89.5C132 86.4624 129.538 84 126.5 84Z"
          stroke="#F2F5F8"
        />
        <path
          d="M68.125 102.125V99.875H68.875V102.125H71.125V102.875H68.875V105.125H68.125V102.875H65.875V102.125H68.125Z"
          fill="#99A0AE"
        />
        <path
          d="M128.5 1H8.5C4.35786 1 1 4.35786 1 8.5V38.5C1 42.6421 4.35786 46 8.5 46H128.5C132.642 46 136 42.6421 136 38.5V8.5C136 4.35786 132.642 1 128.5 1Z"
          stroke="#DD2450"
        />
        <path
          d="M126.5 4.5H10.5C7.18629 4.5 4.5 7.18629 4.5 10.5V36.5C4.5 39.8137 7.18629 42.5 10.5 42.5H126.5C129.814 42.5 132.5 39.8137 132.5 36.5V10.5C132.5 7.18629 129.814 4.5 126.5 4.5Z"
          fill="hsl(var(--neutral-100))"
        />
        <path
          d="M126.5 5H10.5C7.46243 5 5 7.46243 5 10.5V36.5C5 39.5376 7.46243 42 10.5 42H126.5C129.538 42 132 39.5376 132 36.5V10.5C132 7.46243 129.538 5 126.5 5Z"
          stroke="#FB3748"
          stroke-opacity="0.24"
        />
        <path
          d="M69.7004 29.8L68.0204 27.7H64.9004C64.7413 27.7 64.5886 27.6368 64.4761 27.5243C64.3636 27.4117 64.3004 27.2591 64.3004 27.1V20.5618C64.3004 20.4027 64.3636 20.2501 64.4761 20.1375C64.5886 20.025 64.7413 19.9618 64.9004 19.9618H74.5004C74.6595 19.9618 74.8121 20.025 74.9247 20.1375C75.0372 20.2501 75.1004 20.4027 75.1004 20.5618V27.1C75.1004 27.2591 75.0372 27.4117 74.9247 27.5243C74.8121 27.6368 74.6595 27.7 74.5004 27.7H71.3804L69.7004 29.8ZM70.8038 26.5H73.9004V21.1618H65.5004V26.5H68.597L69.7004 27.8788L70.8038 26.5ZM62.5004 17.5H72.7004V18.7H63.1004V25.3H61.9004V18.1C61.9004 17.9409 61.9636 17.7883 62.0761 17.6757C62.1886 17.5632 62.3413 17.5 62.5004 17.5Z"
          fill="#D82651"
        />
        <path
          d="M68.5 49.665V76.335"
          stroke="#CACFD8"
          stroke-width="1.33"
          stroke-linejoin="bevel"
          stroke-dasharray="5 3"
        />
      </g>
      <defs>
        <clipPath id="clip0_17777_780659">
          <rect width="137" height="126" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
